export default "__VITE_ASSET__8bf6284e__"